import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ReportsApi from '../../../API/shipment/reports-api';
import delete_img from '../../../assets/media/bucket.svg';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip, CheckButton, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1 } from '../../../components/Basic/WrapsStyle';
import {
  REPORT_STATUS_TEXT,
  REPORT_TYPE_TEXT,
  STATUS_COLORS,
  TO_REPORT,
  TYPE_BUTTONS
} from '../../../constans';
import { getDate, numberWithSpaces } from '../../../utils';
import CreateReportPopUp from './CreateReportPopUp';
import DeleteReportPopUp from './DeleteReportPopUp';
import styles from './styles.module.scss';
import { Icon } from '../../../components/Basic/Elements';

const width = ['40px', '140px', '150px', '200px'];

const FILTER = {
  0: '',
  1: 'ozon',
  2: 'wb',
  3: 'yandex',
  4: 'kuper',
  5: 'avito',
};

const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  kuper: ['Все', 'kuper1'],
  avito: ['Все', 'avito1'],
};
const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket'];


const MARKET_NAME = {
  ozon: 'Ozon',
  yandex: 'Yandex',
  wb: 'Wb',
  megamarket: 'Megamarket',
  avito: 'Avito',
  Ozon: 'Ozon',
  Yandex: 'Yandex',
  Wb: 'Wb',
  Sber: 'Megamarket',
  kuper: 'Купер',
};

const REPORT_TYPE_MAP = {
  Основной: 'Основной',
  Выкупной: 'Выкупной',
};

function MarketReportsPage() {
  const [create, setCreate] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, realization: {} });

  const [count, setCount] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(50);
  const [shop, setShop] = useState('Все');
  const [reportType, setReportType] = useState('Все');

  const [realizations, setRealizations] = useState([]);
  const [realizationsSelect, setRealizationsSelect] = useState({});
  const user = useSelector((store) => store.user);
  const [endDate, setEndDate] = useState(null);

  const onClickCreate = () => {
    setCreate(true);
  };

  const changeRealizationSelect = (number) => {
    if (realizationsSelect[number]) {
      const s = realizationsSelect;
      delete s[number];
      setRealizationsSelect({ ...s });
    } else {
      setRealizationsSelect({ ...realizationsSelect, [number]: true });
    }
    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  const openManyRealizations = () => { };
  const load = () => {
    ReportsApi.getReports({
      data: {
        status: '',
        market: FILTER[tab],
        shop: shop === 'Все' ? undefined : shop,
        limit: parseInt(show),
        endDate: endDate || undefined,
        reportType: reportType === 'Все' ? undefined : REPORT_TYPE_MAP[reportType],
      }
    }).then((r) => setRealizations(r.reports));
  };

  const onChangeTab = (n) => {
    console.log(n)
    setTab(n);
  };

  const onCloseDelete = () => {
    setDeletePopUp({ show: false, realization: {} });
    load();
  };

  useEffect(() => {
    load();
  }, [tab, show, shop, endDate, reportType]);

  const onChangeReport = (report_id, key, value) => {
    ReportsApi.changeReport({ data: { reportId: report_id, field: key, value } }).then((d) => load());
  };

  const realizations_ids = Object.keys(realizationsSelect);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  useEffect(() => {
    setShop('Все');
  }, [tab]);

  return (
    <>
      <Content>
        <H1>Отчеты маркетплейсов</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все отчеты', 'Ozon', 'Wildberries', 'ЯндексМаркет', 'Купер', 'Avito']}
              num={count}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>
          <Row spaceBetween={true} style={{ marginTop: '25px' }}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['10', '20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />

                {/*                <Select
                  label="Статус отгрузки"
                  select={status}
                  list={STATUSES}
                  width="200px"
                  onSelect={v => changeStatus(v)}
                  style={{ marginRight: '15px' }}
                />*/}
              </div>
              <Select
                label="Тип отчета"
                select={reportType}
                list={['Все', 'Основной', 'Выкупной']}
                onSelect={(v) => setReportType(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
              <Select
                list={SHOPS[FILTER[tab]] || []}
                select={shop}
                disabled={FILTER[tab] === MARKETS_LIST[0]}
                label="Магазин"
                onSelect={(v) => setShop(v)}
                width={'150px'}
                style={{ marginRight: '15px' }}
              />

              <Column style={{ marginRight: '15px' }}>
                <InputLabel>Дата конца периода</InputLabel>
                <Row style={{ position: 'relative', width: '150px' }}>
                  <DateInput value={endDate} className={styles.calendar} onChange={(v) => setEndDate(v)} />
                  <Button className={styles.close_button} onClick={() => setEndDate(null)}>
                    <img src={close} style={{ width: '15px' }} />
                  </Button>
                </Row>
              </Column>
              {isOwner && (
                <Button type={TYPE_BUTTONS.GREEN} onClick={onClickCreate}>
                  Создать отчет
                </Button>
              )}
              {realizations_ids.length > 1 && realizations_ids.length <= 6 && (
                <a href={TO_REPORT(realizations_ids.join('&'))} target={'_blank'} style={{ marginLeft: '10px' }}>
                  <Button type={TYPE_BUTTONS.BLUE} onClick={openManyRealizations}>
                    Открыть совместную реализацию
                  </Button>
                </a>
              )}
            </Row>
            {/*  <Column className={styles.column_button}></Column>*/}
          </Row>
        </WhiteBlock>
        <Table>
          <TableHeader whiteHeader>
            <HeaderTitle width={width[0]} />

            <HeaderTitle width={width[0]}>Id</HeaderTitle>
            <HeaderTitle width={width[1]}>Площадка</HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Период отеча
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Номер отчета
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Тип отчета
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Статус
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Статистика
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Сумма
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Создатель
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText />
          </TableHeader>
          {(realizations || []).map((report) => {
            return (
              <TableLine key={report.id}>
                <TableCell width={width[0]}>
                  <CheckButton
                    checked={realizationsSelect[report.id]}
                    onSelect={() => changeRealizationSelect(report.id)}
                  //disabled={is_disabled_print}
                  />
                </TableCell>
                <TableCell width={width[0]}>{report.id}</TableCell>
                <TableCell width={width[1]}>
                  <NavLink to={TO_REPORT(report.id)} className={styles.line_table_link}>
                    {MARKET_NAME[report.market]} / {report.shop}
                  </NavLink>
                </TableCell>
                <TableCell width={width[3]} center>
                  {getDate(report.period.start)} - {getDate(report.period.end)}
                </TableCell>
                <TableCell width={width[3]} center>
                  {report.report_id_wb}
                </TableCell>
                <TableCell width={width[3]} center>
                  {REPORT_TYPE_TEXT[report.type]}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[report.status]}` }} center>
                  {REPORT_STATUS_TEXT[report.status]}
                </TableCell>
                <TableCell width={width[2]} center>
                  {`${report.statistic_1c?.not_confirmed || 0} / ${report.statistic_1c?.processed || 0} / ${report.statistic_1c?.double || 0
                    } / ${report.statistic_1c?.confirmed || 0}`}{' '}
                  <CheckButton
                    checked={report.is_total_ok}
                    onSelect={(v) => onChangeReport(report.id, 'isTotalOk', !report.is_total_ok)}
                    style={{ marginLeft: '10px' }}
                  />
                </TableCell>
                <TableCell width={width[2]} center>
                  {numberWithSpaces(report.total?.diff?.toFixed(2))}
                </TableCell>
                <TableCell width={width[3]} center>
                  {report.creator}
                </TableCell>

                {report.market === 'wb' ? (
                  <TableCell width={width[3]} center>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => ReportsApi.loadWbReport({ data: { reportId: report.id } })}
                      disabled={report.market != 'wb'}
                    >
                      Выгрузить отчет
                    </Button>
                  </TableCell>
                ) : (
                  <TableCell width={width[3]} center>
                    <SendButton
                      sendApi={report.market === 'yandex' ? ReportsApi.saveReportYandex : ReportsApi.saveReport}
                      sendData={{ data: { reportId: parseInt(report.id), shop: report.shop } }}
                    >
                      Подгрузить отчет
                    </SendButton>
                  </TableCell>
                )}

                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => ReportsApi.createReportRealization({ data: { reportId: report.id } })}
                  style={{ marginLeft: '10px' }}
                >
                  Перенести в подотчетные реализации
                </Button>
                <TableCell styles={styles.delete_cell}>
                  {isOwner && (
                    <ButtonWithTooltip
                      tooltip="Удалить"
                      onClick={() => setDeletePopUp({ show: true, realization: report })}
                    >
                      <Icon src={delete_img} width={'20px'} />
                    </ButtonWithTooltip>
                  )}
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
      </Content>
      {create && (
        <CreateReportPopUp
          close={() => {
            setCreate(false);
            load();
          }}
        />
      )}
      {popUpDelete.show && <DeleteReportPopUp realization={popUpDelete.realization} close={onCloseDelete} />}
    </>
  );
}

export default MarketReportsPage;
